import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import type {
  SessionReplayHandler,
  SessionReplayOptions,
} from '@repo/amplitude/session-replay';

import { ENVIRONMENT } from 'assets/env_constants';
import { getImpersonateId } from 'store/user';

const SESSION_REPLAY_OPTIONS: SessionReplayOptions = {
  sampleRate: 1,
  privacyConfig: {
    defaultMaskLevel: 'conservative',
  },
};

export const useSessionReplay = (
  sessionReplay: SessionReplayHandler | null,
  isEnabled: boolean,
) => {
  const impersonateId = useSelector(getImpersonateId);

  useEffect(() => {
    if (!sessionReplay || !isEnabled) return;
    if (impersonateId) return;
    if (ENVIRONMENT !== 'production') return;

    sessionReplay.start(SESSION_REPLAY_OPTIONS);

    return () => sessionReplay.stop();
  }, [sessionReplay, isEnabled, impersonateId]);
};
